import styled from 'styled-components';

export const EnergyList = styled.ul`
  --card-w: 90px;
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > li {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;
